import React from 'react'
import styled, { keyframes } from 'styled-components'

const SkeletonCard: React.FC = () => (
  <Card>
    <SkeletonImageSection>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px' }}>
        <SkeletonBox width="80px" height="20px" borderRadius="12px" />
        <SkeletonBox width="180px" height="40px" />
        <SkeletonBox width="120px" height="32px" borderRadius="16px" />
      </div>
    </SkeletonImageSection>

    <CardContent>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
        <div>
          <SkeletonBox width="120px" height="14px" style={{ marginBottom: '4px' }} />
          <SkeletonBox width="100px" height="12px" />
        </div>
        <div style={{ textAlign: 'right' }}>
          <SkeletonBox width="60px" height="14px" style={{ marginBottom: '4px' }} />
          <SkeletonBox width="80px" height="12px" />
        </div>
      </div>
      <SkeletonBox width="100%" height="13px" style={{ marginBottom: '4px' }} />
      <SkeletonBox width="80%" height="13px" style={{ marginBottom: '16px' }} />
      <SkeletonBox width="100%" height="44px" borderRadius="6px" />
    </CardContent>
  </Card>
)

const shimmer = keyframes`
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: calc(200px + 100%) 0;
  }
`

const Card = styled.div`
  background: var(--bg-tertiary);
  border-radius: 16px;
  overflow: hidden;
  border: 1px solid var(--zinc-800);

  [data-theme="light"] & {
    border: 1px solid var(--border-primary);
  }
`

const CardContent = styled.div`
  padding: 16px;
`

const SkeletonBox = styled.div<{
  width?: string;
  height?: string;
  borderRadius?: string;
  style?: React.CSSProperties;
}>`
  width: ${props => props.width || '100%'};
  height: ${props => props.height || '20px'};
  border-radius: ${props => props.borderRadius || '4px'};
  background: linear-gradient(90deg, var(--zinc-800) 25%, var(--zinc-700) 50%, var(--zinc-800) 75%);
  background-size: 200px 100%;
  animation: ${shimmer} 1.5s infinite;

  [data-theme="light"] & {
    background: linear-gradient(90deg, var(--border-primary) 25%, var(--bg-tertiary) 50%, var(--border-primary) 75%);
    background-size: 200px 100%;
  }
`

const SkeletonImageSection = styled.div`
  height: 220px;
  background: linear-gradient(90deg, var(--zinc-800) 25%, var(--zinc-700) 50%, var(--zinc-800) 75%);
  background-size: 200px 100%;
  animation: ${shimmer} 1.5s infinite;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;

  [data-theme="light"] & {
    background: linear-gradient(90deg, var(--border-primary) 25%, var(--bg-tertiary) 50%, var(--border-primary) 75%);
    background-size: 200px 100%;
  }
`

export const TournamentsPageSkeleton: React.FC = () => (
  <PageWrapper>
    <SkeletonCard />
    <SkeletonCard />
    <SkeletonCard />
  </PageWrapper>
)

const PageWrapper = styled.div`
  max-width: 600px;
  margin: 0 auto;
  width: 100%;
  min-height: 100vh;
  background: var(--bg-primary);
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export default SkeletonCard